/**
 * Application scripts
 * Usage: Add imports here for third party scripts, such as GSAP
 *
 * Example: import { gsap } from gsap;
 */

import { gsap } from './app/gsap';
import { ScrollTrigger } from './app/ScrollTrigger.js';
import { ScrollSmoother } from './app/ScrollSmoother.js';
import { ScrollToPlugin } from './app/ScrollToPlugin.js';
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);

if (!document.body.classList.contains('page-template-page-ticket-calendar') && !document.body.classList.contains('page-template-page-ots-ticket-calendar')) {
	const smoother = ScrollSmoother.create({
		smooth: 1,
		effects: true,
		smoothTouch: 0.3
	});

	const buttons = gsap.utils.toArray('a[href*="#"]');

	buttons.forEach((b) => {
		b.addEventListener('click', (e) => {
			e.preventDefault();

			const href = e.target.getAttribute('href');

			gsap.to(smoother, {
				scrollTop: Math.min(
					ScrollTrigger.maxScroll(window),
					smoother.offset(href, 'top 100px')
				),
				duration: 1
			});
		});
	});
}

if (document.querySelector('.farlo-ui-crm')) {
	const closeButton = document.querySelectorAll('.farlo-ui-crm__close-group');
	const signupButton = document.querySelectorAll('.farlo-ui-crm__toggle');
	const container = document.querySelector('.site-akt');
	const containerAlt = document.querySelector('.site-akt-alt');
	const overlayContainer = document.querySelector('.site-akt-overlay');

	signupButton.forEach((button) => {
		button.addEventListener('click', () => {
			gsap.to(overlayContainer, {
				duration: 0.5,
				opacity: 1,
				visibility: 'visible',
				onStart: () => {
					if (container) {
						container.classList.add('site-akt--flyout');
						if (document.querySelector('.farlo-ui-crm-toggle-container')) {
							document.querySelector('.farlo-ui-crm-toggle-container').style.visibility = 'hidden';
							document.querySelector('.farlo-ui-crm-toggle-container').style.opacity = 0;
						}
					}

					if (containerAlt) {
						gsap.to(containerAlt, {
							duration: 0.5,
							opacity: 0,
							visibility: 'hidden',
							onStart: () => {
								containerAlt.classList.add('site-akt-alt--fade-out');
							}
						});
					}
					overlayContainer.classList.add('site-akt-overlay--active');
					overlayContainer.style.visibility = 'visible';
				}
			});
		});
	});
	closeButton.forEach((button) => {
		button.addEventListener('click', () => {
			gsap.to(overlayContainer, {
				duration: 0.5,
				opacity: 0,
				onComplete: () => {
					if (container) {
						container.classList.remove('site-akt--flyout');

						if (document.querySelector('.farlo-ui-crm-toggle-container')) {
							document.querySelector('.farlo-ui-crm-toggle-container').style.visibility = 'visible';
							document.querySelector('.farlo-ui-crm-toggle-container').style.opacity = 1;
						}
					}
					if (containerAlt) {
						gsap.to(containerAlt, {
							duration: 0.5,
							opacity: 1,
							visibility: 'visible',
							onComplete: () => {
								containerAlt.classList.remove('site-akt-alt--fade-out');
							}
						});
					}
					overlayContainer.classList.remove('site-akt-overlay--active');
					overlayContainer.style.visibility = 'hidden';
				}
			});
		});
	});
}
